import { styled } from '@mui/material/styles';
import MuiTabs from '@mui/material/Tabs';

export const StyledTabs = styled(MuiTabs)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  .MuiTabs-list {
    padding-left: 0;
  }
`;
